"use client";
import { useState, useEffect } from "react";

import CustomAlert from "../../components/alert/CustomAlert";
import { createUser, sendOTP } from "../../services/apis/user";
import SignUpPopup from "../../components/popup/SignUpPopUp";
import { useLocation } from "react-router-dom";
import { postData } from "../../api/apiDataExchange";

const SignUp = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [affirmation, setAffirmation] = useState(false);
  const [userId, setUserId] = useState("");
  const [isUserInvited, setIsUserInvited] = useState(false);
  const [orgId, setOrgId] = useState();
  const [orgData, setOrgData] = useState([]);
  const [alert, setAlert] = useState(null); // State for CustomAlert
  const location = useLocation();

  const [formData, setFormData] = useState({
    username: "",
    companyName: "",
    PAN: "",
    GST: "",
    designation: "",
    email: "",
    website: "",
    mobile: "",
    landline: "",
    password: "",
    confirmPassword: "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
  });

  const [errors, setErrors] = useState({});

  const handleOpenPopup = () => {
    setOpenPopup(!openPopup);
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    const checkIsInvited = queryParams.get("invited");
    const userEmail = queryParams.get("email");
    const orgId = queryParams.get("orgId");

    const utmSource = queryParams.get("utm_source");
    const utmMedium = queryParams.get("utm_medium");
    const utmCampaign = queryParams.get("utm_campaign");

    if (checkIsInvited === "true") {
      setIsUserInvited(true);
    }
    if (orgId) {
      setOrgId(orgId);
    }
    if (userEmail) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        email: userEmail,
      }));
    }

    setFormData((prevFormData) => ({
        ...prevFormData,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
    }));
  }, [location.search]);

  useEffect(() => {
    console.log({formData: formData.utm_source});

  }, [formData]);

  useEffect(() => {
    const getdata = async () => {
      const payload = {
        id: orgId,
      };
      const response = await postData(
        `${process.env.REACT_APP_API_URL}/organisation/list`,
        payload
      );

      if (response?.data?.data?.results?.length > 0) {
        setOrgData(response?.data?.data?.results);

        }
    };
    getdata();
  }, [orgId]);




  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update form data
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear the error for the specific field
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[name];
      return newErrors;
    });
  };

  const handleOrgChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[name];
      return newErrors;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};

    if (!formData.username.trim()) {
      newErrors.username = "Name is required";
    }

    if (!formData.companyName.trim()) {
      newErrors.companyName = "Company Name is required";
    }

    if (!isUserInvited) {
      const companyExists = orgData.some(
        (org) =>
          org?.name &&
          org?.name?.trim().toLowerCase() ===
            formData?.companyName?.trim()?.toLowerCase()
      );

      if (companyExists) {
        newErrors.companyName = "Company Name already exists";
      }
    }

    if (!formData.email.trim()) {
      newErrors.email = "Company Email is required";
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile Number is required";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    }
    if (!formData.confirmPassword.trim()) {
      newErrors.confirmPassword = "Confirm Password is required";
    }

    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Password and confirm Password is Different";
    }

    setErrors(newErrors);
    console.log(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let payload = {
        ...formData,
        status: "active",
        isUserInvited,
        userType: isUserInvited ? ["user"] : ["admin"],
        ...(orgId && { orgId }), // Include orgId if it exists
      };

      // Add UTM parameters to the payload if they exist
      if (formData.utm_source){
        payload.utm_source = formData.utm_source
      } 
      if (formData.utm_medium){
        payload.utm_medium = formData.utm_medium
      } 
      if (formData.utm_campaign){
        payload.utm_campaign = formData.utm_campaign
      } 

      try {
        const response = await createUser(payload);

        if (response.success) {
          setUserId(response?.result?._id);
          setErrors({});
          setOpenPopup(true);

          try {
            const otpResponse = await sendOTP(response?.result?._id);
            if (otpResponse.success) {
              setAlert({
                message: "OTP Sent.",
                type: "success",
              });
            } else {
              console.error("Error sending OTP:", otpResponse.error);
              setAlert({
                message: "Error sending OTP.",
                type: "error",
              });
            }
          } catch (error) {
            console.error("Error sending OTP:", error);
            setAlert({
              message: "Error sending OTP.",
              type: "error",
            });
          }
        } else {
          if (response["response"]["data"]["error"]["message"]) {
            let message = response["response"]["data"]["error"]["message"];
            console.log("Alert message:", message);
            setAlert({
              message,
              type: "error",
            });
          }
        }
      } catch (error) {
        console.error("Error creating user:", error);
        setAlert({
          message: "Error creating user. Please try again later.",
          type: "error",
        });
      }
    } else {
      console.log("Form submission failed. Please fix the errors.");
      setAlert({
        message: "Please fix the form errors before submitting.",
        type: "error",
      });
    }
  };

  return (
    <>
      <div className="max-w-[1800px] m-auto ">
        <div className="mt-[  ] md:mt-[27px] sm:mx-[20px]  xl:mx-[177px] pb-[32px] md:pb-[3rem] xl:mt-[68px] bg-[#E2F5EC] rounded-[20px] shadow-md flex  justify-center ">
          <div className="w-full p-4 sm:p-0">
            <div
              id="titleText"
              className="text-[#067C4E] mt-[31px]   md:mt-[38px] xl:mt-[41px] text-[24px] font-medium leading-[36px] text-center"
            >
              Be a Part of Us
            </div>
            <div className="text-[14px] font-normal leading-snug text-center text-black">
              Join Us and Be a Part of Something Green!
            </div>

            <div className="mt-[32px] w-full md:px-[115px] xl:px-[184px]">
              <div className="text-black  text-[14px] leading-[21px] font-normal ml-[10px]">
                Name<span className="text-red-600"> *</span>
              </div>
              <div className="mt-[12px]">
                <input
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Enter Name"
                  className="input-placeholder w-full border pl-[20px] rounded-[10px] h-[50px] border-[#B9B9B9]"
                  type="text"
                />
                <br />
                {errors.username && (
                  <p className="text-red-500 m-[10px] mt-[1px] absolute">
                    {errors.username}
                  </p>
                )}
              </div>
            </div>
            <div className={` mt-[32px] w-full md:px-[115px] xl:px-[184px]`}>
              <div className="text-black  text-[14px] leading-[21px] font-normal ml-[10px]">
                Company Name<span className="text-red-600"> *</span>
              </div>
              <div className="mt-[12px]">
                <input
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleOrgChange}
                  placeholder="Enter Company Name"
                  disabled={isUserInvited}
                  className="input-placeholder w-full border pl-[20px] rounded-[10px] h-[50px] border-[#B9B9B9]"
                  type="text"
                />
                <br />
                {errors.companyName && (
                  <p className="text-red-500 m-[10px] mt-[1px] absolute">
                    {errors.companyName}
                  </p>
                )}
              </div>
            </div>
            <div className="md:flex md:px-[115px] md:gap-[50px] xl:px-[184px]">
              <div className="mt-[32px] w-full">
                <div className="text-black  text-[14px] leading-[21px] font-normal ml-[10px]">
                  Company Email<span className="text-red-600"> *</span>
                </div>
                <div className="mt-[12px]">
                  <input
                    name="email"
                    value={formData.email}
                    placeholder="Enter Company Email"
                    className="input-placeholder w-full border pl-[20px]  rounded-[10px] h-[50px] border-[#B9B9B9]"
                    type="email"
                    disabled={isUserInvited}
                    onChange={handleChange}
                  />
                  <br />
                  {errors.email && (
                    <p className="text-red-500 m-[10px] mt-[1px] absolute">
                      {errors.email}
                    </p>
                  )}
                </div>
              </div>

              <div className="mt-[32px] w-full ">
                <div className="text-black  text-[14px] leading-[21px] font-normal ml-[10px]">
                  Mobile<span className="text-red-600"> *</span>
                </div>
                <div className="mt-[12px] mobile-input">
                  <input
                    name="mobile"
                    value={formData.mobile}
                    placeholder="Enter Mobile Number"
                    className="input-placeholder w-full border pl-[20px]  rounded-[10px] h-[50px] border-[#B9B9B9] no-spinner"
                    type="number"
                    onChange={handleChange}
                  />
                  {errors.mobile && (
                    <p className="text-red-500 m-[10px] mt-[1px] absolute">
                      {errors.mobile}
                    </p>
                  )}
                </div>
              </div>
            </div>
            
            <div className="md:flex md:px-[115px] md:gap-[50px] xl:px-[184px]">
              <div className="mt-[32px] w-full">
                <div className="text-black text-[14px] leading-[21px] font-normal ml-[10px]">
                  Password<span className="text-red-600"> *</span>
                </div>
                <div className="mt-[12px]">
                  <input
                    name="password"
                    placeholder="Enter Password"
                    className="input-placeholder w-full border pl-[20px]  rounded-[10px] h-[50px] border-[#B9B9B9]"
                    type="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  {errors.password && (
                    <p className="text-red-500 m-[10px] mt-[1px] absolute">
                      {errors.password}
                    </p>
                  )}
                </div>
              </div>
              <div className="mt-[32px] w-full">
                <div className="text-black  text-[14px] leading-[21px] font-normal ml-[10px]">
                  Confirm Password<span className="text-red-600"> *</span>
                </div>
                <div className="mt-[12px]">
                  <input
                    name="confirmPassword"
                    placeholder="Enter Password Again"
                    className="input-placeholder w-full border pl-[20px] rounded-[10px] h-[50px] border-[#B9B9B9]"
                    type="password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />
                  {errors.confirmPassword && (
                    <p className="text-red-500 m-[10px] mt-[1px] absolute">
                      {errors.confirmPassword}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-[32px] flex justify-center">
              <button
                onClick={handleSubmit}
                className={`h-[44px] rounded-[100px] py-[10px] px-[25px] text-white text-[16px] leading-[24px] ${
                  "bg-[#067C4E]"
                }`}
              >
                Sign Up
              </button>
            </div>
          </div>
        </div>
      </div>
      {openPopup && (
        <SignUpPopup
          setOpenPopup={setOpenPopup}
          openPopUp={openPopup}
          userId={userId}
          handleOpenPopup={handleOpenPopup}
        />
      )}
      {alert && (
        <CustomAlert
          message={alert.message}
          type={alert.type}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default SignUp;
